/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StatisticKeyEnum {
    TEAM_SHAPE = 'team_shape',
    TEAM_MOST_GOALS = 'team_most_goals',
    TEAM_FEWEST_GOALS_AGAINST = 'team_fewest_goals_against',
    TEAM_LONGEST_POSITIVE_STREAK = 'team_longest_positive_streak',
    TEAM_LONGEST_NEGATIVE_STREAK = 'team_longest_negative_streak',
    TEAM_FAIREST = 'team_fairest',
    TEAM_UNFAIREST = 'team_unfairest',
    PLAYER_MOST_GOALS = 'player_most_goals',
    PLAYER_LONGEST_GOAL_STREAK = 'player_longest_goal_streak',
    PLAYER_MOST_YELLOW_CARDS = 'player_most_yellow_cards',
    PLAYER_MOST_RED_CARDS = 'player_most_red_cards',
    PLAYER_FEWEST_GOALS_AGAINST = 'PLAYER_FEWEST_GOALS_AGAINST',
    PLAYER_MOST_ASSISTS = 'player_most_assists',
    PLAYER_MOST_MINUTES = 'player_most_minutes',
    PLAYER_MOST_POST_SHOOTS = 'player_most_post_shoots',
    PLAYER_MOST_MOTM_AWARDS = 'player_most_motm_awards',
    TEAM_MOST_POST_SHOOTS = 'team_most_post_shoots',
    TEAM_MOST_PENALTIES = 'team_most_penalties',
    TEAM_MOST_USED_PLAYERS = 'team_most_used_players',
    TEAM_MOST_GOALS_END = 'team_most_goals_end',
    TEAM_MOST_GOALS_START = 'team_most_goals_start',
    KEEPER_MOST_GAMES_WITHOUT_GOAL = 'keeper_most_games_without_goal',
    PLAYER_MOST_CHANGE_IN = 'player_most_change_in',
    PLAYER_MOST_CHANGE_OUT = 'player_most_change_out',
    PLAYER_MOST_START_11 = 'player_most_start_11',
    PLAYER_MOST_TOTW_AWARDS = 'player_most_totw_awards',
    PLAYER_RATING = 'player_rating',
    PLAYER_FAVOURITE = 'PLAYER_FAVOURITE',
    TEAM_MOST_GOALS_PER_MATCH = 'TEAM_MOST_GOALS_PER_MATCH',
    TEAM_MOST_GOALS_AGAINST_PER_MATCH = 'TEAM_MOST_GOALS_AGAINST_PER_MATCH',
    TEAM_MOST_MATCHES_WITHOUT_GOAL_AGAINST = 'TEAM_MOST_MATCHES_WITHOUT_GOAL_AGAINST',
    TEAM_MOST_YELLOW_CARDS = 'TEAM_MOST_YELLOW_CARDS',
    TEAM_MOST_RED_CARDS = 'TEAM_MOST_RED_CARDS',
    TEAM_HIGHEST_WIN_RATIO = 'TEAM_HIGHEST_WIN_RATIO',
    TEAM_MOST_POINTS_PER_MATCH = 'TEAM_MOST_POINTS_PER_MATCH',
    TEAM_MOST_PENALTIES_FOR = 'TEAM_MOST_PENALTIES_FOR',
    TEAM_MOST_PENALTIES_AGAINST = 'TEAM_MOST_PENALTIES_AGAINST',
    TEAM_MOST_PENALTY_SHOTS_FOR = 'TEAM_MOST_PENALTY_SHOTS_FOR',
    TEAM_MOST_PENALTY_SHOTS_AGAINST = 'TEAM_MOST_PENALTY_SHOTS_AGAINST',
}
